import { Injectable, signal } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { environment } from '../../../environments/environment.development';
import { EnvironmentApiService } from './environment-api.service';
import { ClaimRequestNotification, OfflineUserNotification, OnlineUserNotification, onlineUserNotification, ReassignTasks, TaskNotification, TodayTaskNotification, UserLocationNotification } from '../interfaces/notification.interface';

@Injectable({
  providedIn: 'root'
})
export class NotificationService extends EnvironmentApiService {
  private hubConnection: signalR.HubConnection | undefined;
  claimRequestUpdated = signal<ClaimRequestNotification>({ claimRequestId: 0 });
  taskUpdated = signal<TaskNotification>({ taskId: 0 });
  taskTodayUpdated = signal<TodayTaskNotification>({ taskId: 0,taskCategory:0,facilityBranchId:0,insuranceCompanyBranchId:0 ,hasComment:false,hasResidual:false});
  UserLocationUpdated = signal<UserLocationNotification>({ userId: 0, lat: 0, lng: 0 });
  newOnlineUserAdded = signal<onlineUserNotification>({userId:0,latitude:0,longitude:0});
  newOfflineUser = signal<OfflineUserNotification>({userId:0});
  reassignTasksUpdated = signal<ReassignTasks>({reassignTasksPublished:false});

  //--create Connection
  createNotificationHubConnection() {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${environment.signalRUrl}/notificationHub`, {
      transport: signalR.HttpTransportType.WebSockets |
          signalR.HttpTransportType.ServerSentEvents |
          signalR.HttpTransportType.LongPolling
      })
      .withAutomaticReconnect([0, 2000, 10000, 30000])
      .configureLogging(signalR.LogLevel.Information)
      .build();

    this.hubConnection.start()
      .then(() => {
        console.log('SignalR connection started successfully');
      })
      .catch((error) => {
        console.error('Error starting SignalR connection:', error);
      });

    this.hubConnection.on('UserConnected', (connectionId) => { 
      console.log('User connected with connection ID:', connectionId);
      localStorage.setItem('signalRConnectionId', connectionId);
      this.registerUserToNotificationHub(connectionId);
    });

    //---subscription Methods
    this.hubConnection.on('ClaimRequestPublished', (claimRequestId: number) => {
      console.log('Claim request published:', claimRequestId);
      this.claimRequestUpdated.set({ claimRequestId: claimRequestId });
    });

    this.hubConnection.on('TaskPublished', (taskId: number) => {
      console.log('Task published:', taskId);
      this.taskUpdated.set({ taskId: taskId });
    });
    this.hubConnection.on('TodayTasksPublished', (task: TodayTaskNotification) => {
      console.log('Today tasks published:', task);
      this.taskTodayUpdated.set(task); 
    });
 
    this.hubConnection.on('UserLocationChanged', (userLocation: UserLocationNotification) => {
      console.log('User location changed:', userLocation);
      this.UserLocationUpdated.set(userLocation);
    });

    this.hubConnection.on('ReassignTasksPublished', (reassignTasks: ReassignTasks) => {
      console.log('Reassign tasks published:', reassignTasks);
      this.reassignTasksUpdated.set(reassignTasks);
    });
    

    this.hubConnection.on('NewOnlineUser', (userInfo: OnlineUserNotification) => {
      debugger
      console.log('New online user:', userInfo);
      this.newOnlineUserAdded.set({userId: userInfo.userId,latitude:userInfo.latitude,longitude:userInfo.longitude});
      if (userInfo.userId == this.newOfflineUser().userId)
        this.newOfflineUser.set({userId: 0});
    });
    this.hubConnection.on('NewOfflineUser', (userId: number) => {
      console.log('New offline user:', userId);
      this.newOfflineUser.set({userId: userId});
      if (userId == this.newOnlineUserAdded().userId)
        this.newOnlineUserAdded.set({userId: 0,latitude:0,longitude:0});
    });

    //--close Connection
    this.hubConnection.onclose((error) => {
      console.error('SignalR connection closed. Reconnecting...', error);
      setTimeout(() => this.hubConnection?.start(), 5000);
    });
  }

  registerUserToNotificationHub(currentConnectionId: string) {
    let url = environment.apiUrl + '/SignalRNotification/RegisterUserToNotificationHub';
    return this.httpClient.post(url, { connectionId: currentConnectionId }).subscribe({
      next: (res) => {
        console.log('User registered to notification hub successfully');
      },
      error: (error) => {
        console.error('Error registering user to notification hub:', error);
      }
    });
  }

  // Method to check connection state
  isConnected(): boolean {
    return this.hubConnection?.state === signalR.HubConnectionState.Connected;
  }

  // Method to get connection state for debugging
  getConnectionState(): string {
    return this.hubConnection?.state?.toString() || 'Not initialized';
  }

  // Method to test SignalR connection
  testConnection(): void {
    console.log('SignalR Connection State:', this.getConnectionState());
    console.log('Is Connected:', this.isConnected());
    if (this.hubConnection) {
      console.log('Hub Connection URL:', this.hubConnection.baseUrl);
    }
  }

}
